import React, { useState, useEffect } from 'react';
import { FormGroup, Label, Button,Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';

const FurnishingFilter = ({
  onFilterChange,
  onReset,
  conformingValue = 'all',
  flowStatusValue = 'all',
  shellTypeValue = 'all',
  shellTypeOptions = [],
  flowStatusOptions = [],
  // showShellType = true,
  showConforming = true,
  // showFlowStatus = true,
  resetButtonText = 'Reset',
  className = '',
  filterLayout = 'row',
  showResetBtn = true,
  separateRow = true,
  underFrameOptions = [],
  showUfNo = false,
  underFrameValue = 'all',
  coachNoOptions = [],
  coachNoValue = 'all',
  showCoachNo = false,
  shellTypecoachtypeLabel = 'Shell Type',
  coachNoShellNoLabel = 'Coach No',
}) => {
  const [confirmFilter, setConfirmFilter] = useState(conformingValue);
  const [flowStatusFilter, setFlowStatusFilter] = useState(flowStatusValue);
  const [shellTypeFilter, setShellTypeFilter] = useState(shellTypeValue);
  const [underFrameFilter, setUnderFrameFilter] = useState(underFrameValue);
  const [coachNoFilter, setCoachNoFilter] = useState(coachNoValue);
  // Update internal state when props change
  useEffect(() => {
    setConfirmFilter(conformingValue);
  }, [conformingValue]);

  useEffect(() => {
    setFlowStatusFilter(flowStatusValue);
  }, [flowStatusValue]);

  useEffect(() => {
    setShellTypeFilter(shellTypeValue);
  }, [shellTypeValue]);

  useEffect(() => {
    setUnderFrameFilter(underFrameValue);
  }, [underFrameValue]);

  useEffect(() => {
    setCoachNoFilter(coachNoValue);
  }, [coachNoValue]);

  // Handle individual filter changes
  const handleConfirmChange = (value) => {
    setConfirmFilter(value);
    console.log('Confirm Filter Change from filter component:', value);
    if (onFilterChange) {
      onFilterChange('confirming', value);
    }
  };
  const handleFlowStatusChange = (value) => {
    setFlowStatusFilter(value);
    if (onFilterChange) {
      onFilterChange('flow_status', value);
    }
  };

  const handleShellTypeChange = (value) => {
    setShellTypeFilter(value);
    if (onFilterChange) {
      onFilterChange('shell_type', value);
    }
  };

  // Handle reset
  const handleReset = () => {
    setConfirmFilter('all');
    setFlowStatusFilter('all');
    setShellTypeFilter('all');
    setUnderFrameFilter('all');
    setCoachNoFilter('all');

    if (onFilterChange) {
      onFilterChange('under_frame_no', 'all');
      onFilterChange('coach_no', 'all');
    }

    if (onReset) {
      onReset({
        confirming: 'all',
        flow_status: 'all',
        shell_type: 'all',
        under_frame_no: 'all',
        coach_no: 'all',
      });
    }
  };

  const handleUnderFrameChange = (value) => {
    console.log('111', value);
    setUnderFrameFilter(value);
    if (onFilterChange) {
      onFilterChange('under_frame_no', value);
    }
  };

  const handleCoachNoChange = (value) => {
    setCoachNoFilter(value);
    if (onFilterChange) {
      onFilterChange('coach_no', value);
    }
  };

  // Conforming status options
  const conformingOptions = [
    { value: 'all', label: 'All' },
    { value: '1', label: 'Conforming' },
    { value: '0', label: 'Non-Conforming' },
    // { value: 'na', label: 'NA' },
  ];
  if (!separateRow) {
    return (
      <>
      {showConforming ? (
        <>
        {/* Conforming Status Filter */}
        {conformingOptions && conformingOptions.length > 0 ? (
          <Col md={2}>
            <Label for="confirmFilter" className="fw-bold">
              Conforming Status
            </Label>
            <select
              id="confirmFilter"
              className="form-select"
              style={{ width: '200px' }}
              value={confirmFilter}
              onChange={(e) => handleConfirmChange(e.target.value)}
            >
              {conformingOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </Col>
        ) : (
          ''
        )}
      </> 
      ):''}

        {/* Flow Status Filter */}
        {flowStatusOptions && flowStatusOptions.length > 0 ? (
           <Col md={2}>
            <Label for="flowStatusFilter" className="fw-bold">
              Flow Status
            </Label>
            <select
              id="flowStatusFilter"
              className="form-select"
              value={flowStatusFilter}
              onChange={(e) => handleFlowStatusChange(e.target.value)}
            >
              {flowStatusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </Col>
        ) : (
          ''
        )}

        {/* Shell Type Filter */}
        {shellTypeOptions && shellTypeOptions.length > 0 ? (
           <Col md={2}>
            <Label for="shellTypeFilter" className="fw-bold">
              {shellTypecoachtypeLabel}
            </Label>
            <select
              id="shellTypeFilter"
              className="form-select"
              style={{ width: '250px' }}
              value={shellTypeFilter}
              onChange={(e) => handleShellTypeChange(e.target.value)}
            >
              <option value="all">All</option>
              {Array.isArray(shellTypeOptions) && shellTypeOptions.length > 0 ? (
                shellTypeOptions.map((type) => (
                  <option key={type.id || type.value} value={type.id || type.value}>
                    {type.title || type.name || type.label || type.id}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No shell types available
                </option>
              )}
            </select>
          </Col>
        ) : (
          ''
        )}

        {/* Coach No Filter */}
        {showCoachNo || (coachNoOptions && coachNoOptions.length > 0) ? (
          <FormGroup>
            <Label for="coachNoFilter" className="fw-bold">
              {coachNoShellNoLabel}
            </Label>
            <Select
              inputId="coachNoFilter"
              options={[{ value: 'all', label: 'All' }, ...coachNoOptions]}
              value={
                [{ value: 'all', label: 'All' }, ...coachNoOptions].find(
                  (option) => String(option.value) === String(coachNoFilter),
                ) || { value: 'all', label: 'All' }
              }
              onChange={(option) => handleCoachNoChange(option?.value || 'all')}
              isSearchable
              isClearable={false}
              isDisabled={coachNoOptions.length === 0}
              noOptionsMessage={() => 'No shell numbers available'}
              placeholder="Search shell number"
              styles={{ container: (base) => ({ ...base, width: '250px' }) }}
            />
          </FormGroup>
        ) : (
          ''
        )}
  
        {/* Under Frame No Filter */}
        {underFrameOptions && showUfNo ? (
          <FormGroup>
            <Label for="underFrameFilter" className="fw-bold">
              Under Frame No
            </Label>
            <select
              id="underFrameFilter"
              className="form-select"
              style={{ width: '250px' }}
              value={underFrameFilter}
              onChange={(e) => handleUnderFrameChange(e.target.value)}
            >
              <option value="all">All</option>
              {Array.isArray(underFrameOptions) && underFrameOptions.length > 0 ? (
                underFrameOptions.map((frame) => (
                  <option key={frame.id || frame.value} value={frame.id || frame.value}>
                    {frame.title || frame.name || frame.label || frame.id}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No under frames available
                </option>
              )}
            </select>
          </FormGroup>
        ) : (
          ''
        )}
      </>
    );
  }
  return (
    <div className={`furnishing-filter-container ${className}`}>
      <div
        className={
          filterLayout === 'row'
            ? 'd-flex align-items-end gap-3 flex-wrap'
            : 'd-flex flex-column gap-3'
        }
      >
        {/* Conforming Status Filter */}
        {showConforming ? (
          <>
        {conformingOptions && conformingOptions.length > 0 ? (
          <FormGroup>
            <Label for="confirmFilter" className="fw-bold">
              Conforming Status
            </Label>
            <select
              id="confirmFilter"
              className="form-select"
              style={{ width: '200px' }}
              value={confirmFilter}
              onChange={(e) => handleConfirmChange(e.target.value)}
            >
              {conformingOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </FormGroup>
        ) : (
          ''
        )}
        </>
        ) : ('')}

        {/* Flow Status Filter */}
        {flowStatusOptions && flowStatusOptions.length > 0 ? (
          <FormGroup>
            <Label for="flowStatusFilter" className="fw-bold">
              Flow Status
            </Label>
            <select
              id="flowStatusFilter"
              className="form-select"
              style={{ width: '250px' }}
              value={flowStatusFilter}
              onChange={(e) => handleFlowStatusChange(e.target.value)}
            >
              {flowStatusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </FormGroup>
        ) : (
          ''
        )}

        {/* Shell Type Filter */}
        {shellTypeOptions && shellTypeOptions.length > 0 ? (
          <FormGroup>
            <Label for="shellTypeFilter" className="fw-bold">
              {shellTypecoachtypeLabel}
            </Label>
            <select
              id="shellTypeFilter"
              className="form-select"
              style={{ width: '250px' }}
              value={shellTypeFilter}
              onChange={(e) => handleShellTypeChange(e.target.value)}
            >
              <option value="all">All</option>
              {Array.isArray(shellTypeOptions) && shellTypeOptions.length > 0 ? (
                shellTypeOptions.map((type) => (
                  <option key={type.id || type.value} value={type.id || type.value}>
                    {type.title || type.name || type.label || type.id}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No shell types available
                </option>
              )}
            </select>
          </FormGroup>
        ) : (
          ''
        )}

        {/* Under Frame No Filter */}
        {underFrameOptions && underFrameOptions.length > 0 ? (
          <FormGroup>
            <Label for="underFrameFilter" className="fw-bold">
              Under Frame No
            </Label>
            <select
              id="underFrameFilter"
              className="form-select"
              style={{ width: '250px' }}
              value={underFrameFilter}
              onChange={(e) => handleUnderFrameChange(e.target.value)}
            >
              <option value="all">All</option>
              {Array.isArray(underFrameOptions) && underFrameOptions.length > 0 ? (
                underFrameOptions.map((frame) => (
                  <option key={frame.id || frame.value} value={frame.id || frame.value}>
                    {frame.title || frame.name || frame.label || frame.id}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No under frames available
                </option>
              )}
            </select>
          </FormGroup>
        ) : (
          ''
        )}

        {/* Coach No Filter */}
        {showCoachNo || (coachNoOptions && coachNoOptions.length > 0) ? (
          <FormGroup>
            <Label for="coachNoFilter" className="fw-bold">
              {coachNoShellNoLabel}
            </Label>
            <Select
              inputId="coachNoFilter"
              options={[{ value: 'all', label: 'All' }, ...coachNoOptions]}
              value={
                [{ value: 'all', label: 'All' }, ...coachNoOptions].find(
                  (option) => String(option.value) === String(coachNoFilter),
                ) || { value: 'all', label: 'All' }
              }
              onChange={(option) => handleCoachNoChange(option?.value || 'all')}
              isSearchable
              isClearable={false}
              isDisabled={coachNoOptions.length === 0}
              noOptionsMessage={() => 'No shell numbers available'}
              placeholder="Search shell number"
              styles={{ container: (base) => ({ ...base, width: '250px' }) }}
            />
          </FormGroup>
        ) : (
          ''
        )}

        {/* Reset Button */}
        {showResetBtn && (
          <Button
            type="button"
            color="danger"
            className={filterLayout === 'row' ? 'mb-3' : ''}
            onClick={handleReset}
          >
            {resetButtonText}
          </Button>
        )}
      </div>
    </div>
  );
};

FurnishingFilter.propTypes = {
  onFilterChange: PropTypes.func,
  onReset: PropTypes.func,
  conformingValue: PropTypes.string,
  flowStatusValue: PropTypes.string,
  shellTypeValue: PropTypes.string,
  shellTypeOptions: PropTypes.array,
  flowStatusOptions: PropTypes.array,
  // showShellType: PropTypes.bool,
  showConforming: PropTypes.bool,
  showUfNo: PropTypes.bool,
  // showFlowStatus: PropTypes.bool,
  resetButtonText: PropTypes.string,
  className: PropTypes.string,
  showResetBtn: PropTypes.bool,
  separateRow: PropTypes.bool,
  underFrameOptions: PropTypes.array,
  underFrameValue: PropTypes.string,
  coachNoOptions: PropTypes.array,
  coachNoValue: PropTypes.string,
  showCoachNo: PropTypes.bool,
  shellTypecoachtypeLabel: PropTypes.string,
  coachNoShellNoLabel: PropTypes.string,
  filterLayout: PropTypes.oneOf(['row', 'column']),
};

FurnishingFilter.defaultProps = {
  onFilterChange: null,
  onReset: null,
  conformingValue: 'all',
  flowStatusValue: 'all',
  shellTypeValue: 'all',
  shellTypeOptions: [],
  flowStatusOptions: [],
  resetButtonText: 'Reset',
  underFrameOptions: [],
  coachNoOptions: [],
  showCoachNo: false,
  coachNoShellNoLabel: 'Coach No',
  className: '',
  filterLayout: 'row',
  showResetBtn: true,
  separateRow: true,
  underFrameValue: 'all',
  coachNoValue: 'all',
  shellTypecoachtypeLabel: 'Shell Type',
};

export default FurnishingFilter;
